var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5C15 4.69322 14.7602 4.44452 14.4643 4.44452H1.82977L5.20134 0.949468C5.33684 0.808963 5.38975 0.604174 5.34016 0.412241C5.29056 0.220309 5.14599 0.0703921 4.9609 0.018964C4.77581 -0.0324642 4.57831 0.022409 4.44282 0.162913L0.157376 4.60672C0.0566236 4.71094 0 4.85244 0 5C0 5.14756 0.0566236 5.28906 0.157376 5.39328L4.44282 9.83709C4.57831 9.97759 4.77581 10.0325 4.9609 9.98104C5.14599 9.92961 5.29056 9.77969 5.34016 9.58776C5.38975 9.39583 5.33684 9.19104 5.20134 9.05053L1.82977 5.55548H14.4643C14.7602 5.55548 15 5.30678 15 5Z",
    fill: "currentColor"
  })));
};

export { SvgArrowLeft as ReactComponent };
export default __webpack_public_path__ + "3f5e1f476698f9c24c34942a710a5566.svg";